/* eslint-disable no-param-reassign */
import translations from './zn';

export default (template, replacements) => {
  replacements = replacements || {};

  // Translate
  template = translations[template] || template;

  // Replace
  return template.replace(/{([^}]+)}/g, (_, key) => replacements[key] || `{${key}}`);
};
